import { FormControl, Validators } from '@angular/forms';
import { AVAILABLE_USER_LANGUAGES } from './languages.const';

editUserLanguageController.$inject = ['$scope', '$mdDialog', '$translate', 'elementData', 'elementView'];
export function editUserLanguageController($scope, $mdDialog, $translate, elementData, elementView) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.remove = remove;
  $scope.languageCtrl = new FormControl(null, Validators.required);

  _ngOnInit();

  function ok() {
    elementData.lang = $scope.languageCtrl.value;
    elementData.label = $translate.instant(AVAILABLE_USER_LANGUAGES[elementData.lang]);
    $mdDialog.hide({ type: 'ok', data: elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function remove() {
    $mdDialog.hide({ type: 'delete' });
  }

  function __getRemainingItems() {
    const selected = elementView.getAlreadySelectedUserLanguages();
    $scope.items = Object.keys(AVAILABLE_USER_LANGUAGES)
      .filter(key => !selected.includes(key))
      .map((key) => ({
        id: key,
        label: $translate.instant(AVAILABLE_USER_LANGUAGES[key])
      }));
  }

  function _ngOnInit() {
    __getRemainingItems();
    $scope.languageCtrl.setValue(elementData.lang);
  }
}
